import React from 'react';
import PropTypes from 'prop-types';
import realtyOneLogo from 'images/realty-one-group-color-large-logo.png';

export default function AgentContact({ agent, pushDataInToDataLayer }) {
  return (
    <section className="agent-contact-container">
      {agent ? (
        <div className="agent-info-container">
          <a
            href={`/agents/${agent.id}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${agent.first_name} ${agent.last_name}'s Profile`}
          >
            <img
              data-src={agent.profile_photo_url}
              alt={`${agent.first_name} ${agent.last_name}`}
              title={`${agent.first_name} ${agent.last_name}`}
              className="lazyload"
            />
          </a>
          <div className="agent-text-info">
            {/* <p className="agent-broker-name">Realty One Agent</p> */}
            <img
              src={realtyOneLogo}
              alt="Realty One Group"
              className="agent-broker-name image"
            />
            <a
              href={`/agents/${agent.id}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${agent.first_name} ${agent.last_name}'s Profile`}
            >
              <p className="agent-name">
                {agent.first_name} {agent.last_name}
              </p>
            </a>
            <p className="agent-designation">{agent.designation}</p>
          </div>
        </div>
      ) : (
        <div className="agent-info-container no-agent">
          <div className="agent-text-info">
            <p className="agent-name">
              Interested in more info about this property?
            </p>
            <p className="agent-broker-name">
              Contact a Realty One Group Agent Today
            </p>
          </div>
        </div>
      )}

      <button
        type="button"
        title=""
        aria-label=""
        onClick={() => {
          document
            .querySelector('#mls-inquiry-modal')
            .classList.remove('hidden');

          pushDataInToDataLayer();
        }}
        className="btn btn--blue-grad contact-agent"
      >
        Contact Agent
      </button>
    </section>
  );
}

AgentContact.propTypes = {
  agent: PropTypes.object,
};
